import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/shared/config/constants';
import { useThemeColors } from '@/shared/theme/useThemeColors';
import { semantic, typography } from '@/shared/theme/tokens';

export default function ForbiddenPage() {
  const navigate = useNavigate();
  const c = useThemeColors();

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: c.bgPage, fontFamily: typography.fontFamily.body }}
    >
      <div className="text-center max-w-sm px-4">
        <span
          className="material-symbols-outlined text-[64px] text-error mb-4 block"
          style={{ fontVariationSettings: "'FILL' 0" }}
        >
          block
        </span>
        <h1
          className="text-2xl font-bold text-on-surface mb-2"
          style={{ fontFamily: typography.fontFamily.heading }}
        >
          Access Denied
        </h1>
        <p className="text-sm text-on-surface-variant mb-6">
          You do not have permission to view this page. Contact your administrator if you believe this is an error.
        </p>
        <button
          onClick={() => navigate(ROUTES.DEPLOYMENTS)}
          className="text-on-primary rounded-lg px-6 py-2.5 text-xs font-semibold tracking-widest uppercase inline-flex items-center gap-2"
          style={{ background: semantic.brandGrad }}
        >
          <span className="material-symbols-outlined text-[16px]">home</span>
          Go to Deployments
        </button>
      </div>
    </div>
  );
}
